/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Desktop_Step_1_DescInputs */

const en_mk_desktop_step_1_desc = /** @type {(inputs: Mk_Desktop_Step_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open bystep-desktop from the extracted download folder. Select “Connect account”, then confirm in your browser.`)
};

const id_mk_desktop_step_1_desc = /** @type {(inputs: Mk_Desktop_Step_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka bystep-desktop dari folder unduhan yang sudah diekstrak. Klik “Hubungkan akun”, lalu konfirmasi di browser.`)
};

/**
* | output |
* | --- |
* | "Open bystep-desktop from the extracted download folder. Select “Connect account”, then confirm in your browser." |
*
* @param {Mk_Desktop_Step_1_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_desktop_step_1_desc = /** @type {((inputs?: Mk_Desktop_Step_1_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Desktop_Step_1_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_desktop_step_1_desc(inputs)
	return en_mk_desktop_step_1_desc(inputs)
});